import * as styles from './styles.module.scss';

const RateAndReviewEmpty = () => (
  <div className={styles.container} data-testid="rate-and-review-empty">
    <div className={styles.stars}>
      <i className="fal fa-star" />
      <i className="fal fa-star" />
      <i className="fal fa-star" />
      <i className="fal fa-star" />
      <i className="fal fa-star" />
    </div>
    <p className={styles.title} data-testid="blank-state-text">
      No Products to Review
    </p>
    <p className={styles.subtitle}>There are no products available here yet.</p>
  </div>
);

export default RateAndReviewEmpty;
